import {connect} from 'react-redux'

import LayoutWithAdminDrawer from '../components/LayoutWithAdminDrawer'

const mapStateToProps = state => ({
  adminDrawerOpen: state.admin.adminDrawerOpen
})

export default connect(mapStateToProps)(LayoutWithAdminDrawer)
